import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const LocalizationPage = lazy(() => import('./LocalizationPage'));

const localizationRoute: FuseRouteItemType = {
	path: 'localization',
	children: [{ index: true, element: <LocalizationPage /> }]
};

export default localizationRoute;
